module.exports = __webpack_public_path__ + "img/hand-fingers-crossed.6d72dfd5.svg";